<template>
  <div class="lenossa-fluid" :class="{'lenossa-fluid--dark' : selectedColorPallet === 'dark'}">
    <svg class="letter l" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.61 402.99">
      <polygon points="0 402.99 0 368.1 51.81 368.1 51.81 34.89 0 34.89 0 0 93.03 0 93.03 368.1 137.61 368.1 137.61 402.99 0 402.99" />
    </svg>
    <svg class="letter e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.85 292.79">
      <path d="M288.06,144.32a13.42,13.42,0,0,0,1.74-3.06,13.24,13.24,0,0,0,.65-2,11.62,11.62,0,0,0,.19-4.43,18,18,0,0,0,.15-3.41c-5.89-39-20.44-69.59-44.66-91.07C215.88,13.59,181.77,0,144.74,0,107,0,73,13.9,43.8,41.3,14.33,69,0,103.28,0,146.25,0,191.54,14.66,226.46,44.82,253s66.8,39.81,109.28,39.81A185.32,185.32,0,0,0,233.4,275c15.09-7.09,30-15.29,40.34-28.33,19.06-24.06-15.45-37.58-31.78-21.48-23,22.68-52.05,34.15-86.66,34.15-29.56,0-54.27-9.16-73.44-27.24-32.11-30.29-39.06-70-32.31-114.23,3.89-25.49,14.79-46.62,32.39-62.81,17.76-16.33,39.39-24.61,64.3-24.61,27.19,0,50.48,9.13,69.27,27.14,18.43,17.7,29.59,38,34.31,60,.32,1.48.63,3.21.94,4.86H134.34c-23.18,0-28.54,30.32-7.92,30.32H267.16a33.16,33.16,0,0,0,12.08-2.2,17.31,17.31,0,0,0,4.76-2.24c.31-.21.64-.38.92-.6A14.12,14.12,0,0,0,288.06,144.32Z" />
    </svg>
    <svg class="letter n-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145.25 280.44">
      <polygon points="94.06 244.93 94.06 73.99 94.06 43.64 94.06 0 0 0 0 35.51 52.11 35.51 52.11 244.93 0 244.93 0 280.44 94.06 280.44 145.25 280.44 145.25 244.93 94.06 244.93" />
    </svg>
    <svg class="letter n-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178.61 274.85">
      <path d="M178.61,239.34v35.51H86.7V89c0-49-27.58-53.27-39.58-53.73C37,34.84,27.2,40.15,23.42,43.51c-10.56,9.43-35-15.83-17-31.82C14,5,32,0,51.61,0s61.52,10.05,68.61,34.56c7.08,24.11,8.42,43.74,8.42,204.78Z" />
    </svg>
    <svg class="letter o-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 244.95 172.94">
      <path d="M.91,41.47c-4.58,20.14,8.62,32.4,29.58,29.45,11.81-16,39.7-32.18,72.26-32.18h.1c27.12,0,50.54,9.92,69.6,29.43,22.67,23.2,30.36,52,27.9,84.05,0-.06,41.62,20.72,41.62,20.72C269.89,19.64,94.52-51.22.91,41.47Z" />
    </svg>
    <svg class="letter o-bottom" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 244.95 172.94">
      <path d="M244,131.47c4.58-20.14-8.62-32.4-29.59-29.45-11.8,16-39.69,32.18-72.26,32.18h-.09c-27.12,0-50.54-9.92-69.6-29.43-22.67-23.2-30.37-52-27.91-84C44.59,20.78,3,0,3,0-24.95,153.3,150.43,224.16,244,131.47Z" />
    </svg>
    <svg class="letter s-top s-top-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.82 134.47">
      <path d="M51.12,96.84c-7-4.57-16.59-11.09-16.59-27.56,0-12.34,5.76-22.74,16.67-30.05C61.34,32.44,74.21,29,89.46,29,119.1,29,142,41.21,157.6,65.28l1.18,1.83V78.24h32V4.15h-32V20.91l-11-6.26C130.72,4.93,110,0,86.14,0,60.08,0,38.91,7,23.21,20.74S0,51,0,71.26c0,20.12,6.92,36,21.15,48.61C58,152.47,92.68,124.08,51.12,96.84Z" />
    </svg>
    <svg class="letter s-bottom s-bottom-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.82 133.98">
      <path d="M139.7,37.14c7.26,4.1,16.59,11.09,16.59,27.56,0,12.34-5.76,22.74-16.67,30.05-10.14,6.79-23,10.23-38.26,10.23C71.72,105,48.79,92.77,33.22,68.7L32,66.87V55.74H0v74.09H32V113.07l11,6.27C60.1,129.05,80.83,134,104.68,134c26.06,0,47.23-7,62.93-20.74S190.82,83,190.82,62.72c0-20.12-6.92-36-21.15-48.61-4.51-4-8.59-7.94-16.67-10.95C118.82-9.58,107.79,19.15,139.7,37.14Z" />
    </svg>
    <svg class="letter s-top s-top-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.82 134.47">
      <path d="M51.12,96.84c-7-4.57-16.59-11.09-16.59-27.56,0-12.34,5.76-22.74,16.67-30.05C61.34,32.44,74.21,29,89.46,29,119.1,29,142,41.21,157.6,65.28l1.18,1.83V78.24h32V4.15h-32V20.91l-11-6.26C130.72,4.93,110,0,86.14,0,60.08,0,38.91,7,23.21,20.74S0,51,0,71.26c0,20.12,6.92,36,21.15,48.61C58,152.47,92.68,124.08,51.12,96.84Z" />
    </svg>
    <svg class="letter s-bottom s-bottom-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.82 133.98">
      <path d="M139.7,37.14c7.26,4.1,16.59,11.09,16.59,27.56,0,12.34-5.76,22.74-16.67,30.05-10.14,6.79-23,10.23-38.26,10.23C71.72,105,48.79,92.77,33.22,68.7L32,66.87V55.74H0v74.09H32V113.07l11,6.27C60.1,129.05,80.83,134,104.68,134c26.06,0,47.23-7,62.93-20.74S190.82,83,190.82,62.72c0-20.12-6.92-36-21.15-48.61-4.51-4-8.59-7.94-16.67-10.95C118.82-9.58,107.79,19.15,139.7,37.14Z" />
    </svg>
    <svg class="letter a-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180.84 172.63">
      <path d="M126,30.7c-38.62-6.92-83.69,5.59-87.1,52.64-3.62,49.93,50.85,60.76,63.23,60.37,33.65-1.07,41.68-13,55.64-17.43,19.87-6.24,31.84,9.64,15.16,24.33C123.5,194.16-9,174.11.48,81.51,6,27.45,62.22-15.18,132.05,5.18,153.67,11.48,144.45,34,126,30.7Z" />
    </svg>
    <svg class="letter a-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270.2 284.63">
      <path d="M220.94,249.63V106.2c0-23-1.3-39.84-3.84-50A67.91,67.91,0,0,0,202.88,29c-5.27-6.28-12.9-11.78-22.69-16.46-3.05-1.46-6.29-2.85-9.77-4.14C155.37,2.83,137.14,0,116.25,0,63.15,0,24.73,17.46,2.18,55.19c-11.45,19.17,25.27,29.41,39,10.29C56.57,44,78,32.28,107.49,32.28c18.16,0,33.26,3.67,44.89,10.89,11.91,7.41,19.7,16.13,23.13,25.93,3.15,9,4.68,21.15,4.68,37.1V221.49c0,46.58.06,31.74-.22,62.91l90.23.23v-35Z" />
    </svg>
  </div>
</template>

<script>
import { gsap, Power2 } from 'gsap'

export default {
  name: 'LenossaPieces',
  props: {
    selectedColorPallet: String
  },
  methods: {
    randomNumber (min, max) {
      if (!min) min = 0
      if (!max) max = 0
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  },
  mounted () {
    let letters = document.querySelectorAll('.letter')
    let animationDelay = 0
    letters.forEach(letter => {
      gsap.to(letter, {
        y: '+=8px',
        repeat: -1,
        yoyo: true,
        delay: animationDelay,
        duration: 2.5,
        ease: Power2.easeInOut })
      gsap.fromTo(letter, this.randomNumber(4, 5),
        {
          ease: Power2.easeInOut,
          rotation: this.randomNumber(-10, -5)
        },
        {
          repeat: -1,
          yoyo: true,
          ease: Power2.easeInOut,
          rotation: this.randomNumber(5, 10)
        }
      )
      animationDelay += 0.4
    })
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  .lenossa-fluid
    @apply relative inline-flex items-end
    height: 4em
    @screen i5c
      transform: scale(0.8)
      transform-origin: left center
    @screen lg
      height: 6em
    svg
      @apply absolute pin-b
    .l                              // dimensions
      @apply h-full
      left: 0
    .e
      height: 70%
      left: 1.6em
      @screen lg
        left: 2em
    .n-left
      height: 68%
      left: 4.9em
      @screen lg
        left: 6.4em
    .n-right
      height: 66%
      left: 6.5em
      @screen lg
        left: 8.5em
    .o-bottom
      height: 42%
      left: 8.6em
      @screen lg
        left: 11.4em
    .o-top
      height: 42%
      left: 9.1em
      bottom: 1.1em
      @screen lg
        left: 12em
        bottom: 1.4em
    .s-bottom-1
      height: 32%
      left: 12.2em
      @screen lg
        left: 16.2em
    .s-top-1
      height: 32%
      left: 12.2em
      bottom: 1.5em
      @screen lg
        left: 16.2em
        bottom: 2.1em
    .s-bottom-2
      height: 32%
      left: 14.7em
      @screen lg
        left: 19.4em
    .s-top-2
      height: 32%
      left: 14.7em
      bottom: 1.5em
      @screen lg
        left: 19.5em
        bottom: 2.1em
    .a-left
      height: 42%
      left: 17.2em
      @screen lg
        left: 22.5em
    .a-right
      height: 70%
      left: 17.5em
      @screen lg
        left: 22.7em
    &--dark
      .letter
        path, polygon
          fill: #F4E2B0

  .letter
    path, polygon
      fill: #FFD443

</style>
